/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Frame) GS.Toolbar.Frame={};
GS.Toolbar.Frame.ShadowTools=new Class({
    Extends: GS.Toolbar.Tools,
    class_name:'GS.Toolbar.Frame.ShadowTools',
    options:{
        'wrapper': null,
        'class':'submenu full',
        'lexico':{'x':'Position X','y':'Position Y','o':'Opacity','b':'Blur','enable':'Add shadow'},
        'toolbar':null
    },
    controlled:null,
    initialize:function(conf){
       this.options.lexico=Locale.get('Toolbar.shadow');
       this.parent(conf);
    }
});

GS.Toolbar.Frame.ShadowTools.prototype.addListeners=function(obj,evs){
    if(!evs.pop) evs=[evs];
    //console.debug('@ShadowTools Add Event %s',evs);
    Array.each(evs,function(p,i){
        
        obj.addEvent(p,function(v){
            //console.debug('Event reached',p);
            //this.fireEvent.apply(this,arguments);
        });
    }.bind(this));
};

GS.Toolbar.Frame.ShadowTools.prototype.updatePermissions=function(p){
    try{
        var d=(p.shadow) ? 'block' : 'none';
        var s= (p.shadow) ? 1 : 0;
        this.options.wrapper.setStyle('display',d);
        this.options.wrapper.store('status',1);
        if(s) this.toolbar.fireEvent('show');
    }catch(err){}
};

GS.Toolbar.Frame.ShadowTools.prototype.menuTMPL=function(){
    //var out='    <li class="slider effect-brightness" data-type="effect-brightness" data-uitype="slider"><label>{l}</label></li>';
    var out ='      <li class="slider shadow-color" data-type="shadow-color"  id="toolbar-shadow-color" data-uitype="colorpicker"><div class="color-placeholder"  title="{tooltip_c}"></div></li>';
    out+='   <li class="on-off" data-uitype="checkbox" data-type="shadow-on" title="{tooltip_enable}"><label>{enable}</label></li>';
    out+='      <li class="slider shadow-x" data-type="shadow-x" data-uitype="slider_w_input" title="{tooltip_x}"><label class="min">{xMin}</label><label>{x}</label><label class="max">{xMax}</label></li>';
    out+='      <li class="separator-h"></li>';
    out+='      <li class="slider shadow-y" data-type="shadow-y" data-uitype="slider_w_input" title="{tooltip_y}"></div><label class="min">{yMin}</label><label>{y}</label><label class="max">{yMax}</label></li>';
    out+='      <li class="separator-h"></li>';
    out+='      <li class="slider shadow-opacity" data-type="shadow-opacity" data-uitype="slider_w_input" title="{tooltip_o}"></div><label class="min">{oMin}</label><label>{o}</label><label class="max">{oMax}</label></li>';
    out+='      <li class="separator-h"></li>';
    out+='      <li class="slider shadow-blur" data-type="shadow-blur" data-uitype="slider_w_input" title="{tooltip_b}"></div><label class="min">{bMin}</label><label>{b}</label><label class="max">{bMax}</label></li>';
    

    return out;
};


/*GS.Toolbar.Frame.ShadowTools.prototype.menuTMPL=function(){
    //var out='    <li class="slider effect-brightness" data-type="effect-brightness" data-uitype="slider"><label>{l}</label></li>';
    var out='   <li class="on-off" data-uitype="checkbox" data-type="shadow-on" title="{tooltip_enable}"><label>{enable}</label></li>';
    out+='      <li class="slider shadow-x" data-type="shadow-x" data-uitype="slider" title="{tooltip_x}"><label class="min">{xMin}</label><label>{x}</label><label class="max">{xMax}</label><input type="number" name="shadow-x-input-value" value="" step="0.1" min="-25" max="25"/></li>';
    //out+='      <li class="shadow-x" data-type="shadow-x" data-uitype="slider" title="{tooltip_x}">';
    //out+='          <label class="min">{xMin}</label><alk-slider min="{xMin}" max="{xMax}" value="0.25" step="0.01"></alk-slider><label>{x}</label><label class="max">{xMax}</label><input type="number" name="shadow-x-input-value" value="" step="0.1" min="-25" max="25"/></li>';
    out+='      <li class="separetor-h"></li>';
    out+='      <li class="slider shadow-y" data-type="shadow-y" data-uitype="slider" title="{tooltip_y}"></div><label class="min">{yMin}</label><label>{y}</label><label class="max">{yMax}</label><input type="number" name="shadow-y-input-value" value="" step="0.1" min="-25" max="25"/></li>';
    out+='      <li class="separetor-h"></li>';
    out+='      <li class="slider shadow-opacity" data-type="shadow-opacity" data-uitype="slider" title="{tooltip_o}"></div><label class="min">{oMin}</label><label>{o}</label><label class="max">{oMax}</label><input type="number" name="shadow-o-input-value" value="" step="0.1" min="0" max="100"/></li>';
    out+='      <li class="separetor-h"></li>';
    out+='      <li class="slider shadow-blur" data-type="shadow-blur" data-uitype="slider" title="{tooltip_b}"></div><label class="min">{bMin}</label><label>{b}</label><label class="max">{bMax}</label><input type="number" name="shadow-b-input-value" value="" step="0.1" min="0" max="50"/></li>';
    
    out+='      <li class="slider shadow-color" data-type="shadow-color"  id="toolbar-shadow-color" data-uitype="colorpicker"><div class="color-placeholder"  title="{tooltip_c}"></div></li>';
    return out;
};*/